import * as React from "react";

function SvgPersistIq(props, ref) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 100 100"
      xmlns="http://www.w3.org/2000/svg"
      {...{ ...props, ref }}
    >
      <path
        d="M8 0h84a8 8 0 018 8v83.615a8 8 0 01-8 8H8a8 8 0 01-8-8V8a8 8 0 018-8zm24.92 77.799v-16.66H54.6c14.156 0 22.1-7.518 22.1-19.187 0-11.772-7.842-19.73-22.1-19.73H21.916V77.8H32.92zm0-27.782V33.341h20.05c6.721 0 11.508 2.003 11.508 8.611 0 6.506-4.787 8.065-11.508 8.065H32.92z"
        fill="#1E3D46"
        fillRule="evenodd"
      />
    </svg>
  );
}

export default React.forwardRef(SvgPersistIq);
